import React from 'react';

import Icon from 'ds/Icon';
import Layout from 'ds/Layout';
import Text from 'ds/Text';
import { Color } from 'shared';

import Circle from './Circle';

interface Props {
  dotColor: Color;
  color: Color;
  text: string;
  dotPosition?: 'left' | 'right';
  textColor?: Color;
  includeCaret?: boolean;
  size?: 'sm' | 'lg';
}

const StatusDisplay: React.FC<Props> = ({
  text,
  dotColor,
  color,
  dotPosition = 'left',
  textColor = 'gray-900',
  includeCaret = false,
  size = 'lg'
}) => {
  return (
    <Layout
      color={color}
      {...(size === 'sm' ? { paddingLeft: 10, paddingRight: 12, paddingY: 4 } : { paddingX: 12, paddingY: 6 })}
      borderRadius={4}
      align="center"
      direction={dotPosition === 'right' ? 'row-reverse' : undefined}
      justify="center"
    >
      <Circle dimension={8} color={dotColor} />
      <Layout marginLeft={6}>
        <Text size={size === 'sm' ? 'tag' : 'body-sm'} color={textColor} semibold>
          {text}
        </Text>
      </Layout>
      {includeCaret && <Icon name="downCaret" size={16} color={dotColor} />}
    </Layout>
  );
};

export default StatusDisplay;
